import { UserCard } from '@widgets/user';
import type { User } from '@entities/user';

type UserInfoSupportProps = {
  user: User;
  editLink: string;
};

export const UserInfoSupport = ({ user, editLink }: UserInfoSupportProps) => {
  return (
    <UserCard
      isEdit
      editLink={editLink}
      firstName={user.profile.firstName}
      lastName={user.profile.lastName}
      email={user.email}
      group={user.role.name}
      phone={user.profile.phone}
    />
  );
};
